import get from 'lodash/get';

import { type GenericObject } from '../types';

import { getFullMonthsSince, isDateValid, MONTH_NUM_IN_YEAR, type NativeDateType } from './dateUtils';

// getDataByKey([{a:1, b:2}, {a:5, b:6}], "a") => {"1": {a:1, b:2}, "5": {a:5, b:6}}
export const getDataByKey = <T extends object>(data: T[], keyName: keyof T): GenericObject<T> => {
    return data.reduce((acc: any, next) => {
        acc[next[keyName]] = next;
        return acc;
    }, {});
};

// getDataByKeyAndValue([{a:1, b:2}, {a:5, b:6}], "a", "b") => {"1": "2", "5": "6"}
export const getDataByKeyAndValue = <T extends object>(
    data: T[],
    key: keyof T,
    pathToValue: string,
    defaultValue?: string
) => {
    return data.reduce((acc: any, next) => {
        acc[next[key]] = get(next, pathToValue, defaultValue);
        return acc;
    }, {});
};

export const getOptionFieldById = (
    options: Array<{ _id: string } & GenericObject<any>> = [],
    fieldName: string,
    id: string
) => {
    return options.find((option) => option._id === id)?.[fieldName] || '';
};

export function calcAgeByBirthDate(birthDate: NativeDateType | null) {
    if (!birthDate || !isDateValid(birthDate)) return '';

    const month = getFullMonthsSince(birthDate);
    return `${Math.floor(month / MONTH_NUM_IN_YEAR)}.${month % MONTH_NUM_IN_YEAR}`;
}

export const doesPropertyNameExist = (
    values: any,
    tableData: any[],
    keySearch: string = 'accountName'
): boolean => {
    const findDuplicateEntry = tableData?.find((data) => {
        const isDuplicateKeyName =
            data[keySearch]?.trim()?.toLowerCase() === values[keySearch]?.trim()?.toLowerCase();
        return isDuplicateKeyName && data._id !== values._id;
    });
    return !!findDuplicateEntry;
};
